import { NewsletterService } from '@/services/newsletterService';

/**
 * Format a number to a readable string (e.g., 1000 -> "1K", 1500000 -> "1.5M")
 */
export function formatNumber(num: number): string {
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1).replace('.0', '') + 'M';
  }
  if (num >= 1000) {
    return (num / 1000).toFixed(1).replace('.0', '') + 'K';
  }
  return num.toString();
}

/**
 * Calculate the total laughs generated based on subscribers and comics published
 * @param subscriberCount Number of newsletter subscribers
 * @param comicsPublished Number of comics published
 * @returns Formatted string of total laughs
 */
export function calculateLaughs(subscriberCount: number, comicsPublished: number): string {
  const totalLaughs = subscriberCount * comicsPublished;
  return formatNumber(totalLaughs) + '+';
}

/**
 * Get the laughs generated value, with fallback handling
 * @param comicsPublished Number of comics published
 * @returns Promise<string> Formatted laughs string
 */
export async function getLaughsGenerated(comicsPublished: number): Promise<string> {
  try {
    const subscriberCount = await NewsletterService.getSubscriberCount();
    return calculateLaughs(subscriberCount, comicsPublished);
  } catch (error) {
    console.error('Error calculating laughs:', error);
    return NewsletterService.getFallbackLaughs();
  }
}